import {AFD} from 'devegram-javascript-util'

const baseUrl = '/xapi/Voip/VendorDestinationStatus';
const baseUrl2 = '/xapi/VoipMrt/VendorDestinationStatus';
const moduleAjaxService = 'backend-service'
const api = {
    namespaced: true,
    state: {},
    actions: {
        async mrtCreate(context, params) {
            let api = {
                verb: 'post',
                service: moduleAjaxService,
                url: baseUrl2 + '/store',
                data: AFD(params.data)
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r);
                }).catch(e => {
                    reject(e);
                })
            })
        },
        async create(context, params) {
            let api = {
                verb: 'post',
                service: moduleAjaxService,
                url: baseUrl + '/store',
                data: AFD(params.data)
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r);
                }).catch(e => {
                    reject(e);
                })
            })
        },
        async update(context, params) {
            let api = {
                verb: 'post',
                service: moduleAjaxService,
                url: baseUrl + '/update/' + params.id,
                data: AFD(params.data),
                noLoadingScreen: true
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r);
                }).catch(e => {
                    reject(e);
                });
            })
        },
        async remove(context, params) {
            let api = {
                verb: 'post',
                service: moduleAjaxService,
                url: baseUrl + '/remove/' + params.id
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r);
                }).catch(e => {
                    reject(e);
                });
            })
        },
        async get(context, params) {
            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseUrl + '/get/' + params.id
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r);
                }).catch(e => {
                    reject(e);
                });
            })
        },
        async downloadWorkingDestinations(context, params) {
            let fileName = 'new-ffr-working-destinations2'
            let fileType = 'xlsx'

            const link = document.createElement('a');
            link.href = process.env.VUE_APP_VOIP_GENERAL_BACKEND_SERVICE_URL + ":" + process.env.VUE_APP_VOIP_GENERAL_BACKEND_SERVICE_PORT + baseUrl + '/downloadWorkingDestinations';
            link.setAttribute('download', fileName + '.' + fileType);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            /*return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    const url = window.URL.createObjectURL(
                        new Blob([r.data], { type: contentTypes[fileType] })
                    );
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', fileName + '.' + fileType);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }).catch(e => {
                    reject(e);
                });
            })*/

            /*return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    const url = window.URL.createObjectURL(
                        new Blob([r.data], { type: contentTypes[fileType] })
                    );
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', fileName + '.' + fileType);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }).catch(e => {
                    reject(e);
                });
            })*/
        },
        async list(context, params) {
            let page = 'page=' + ((params.page) ? params.page : 1)
            let pageChunk = "&page-chunk=20"
            let statusId = (params.hasOwnProperty('statusId'))? "&statusId=" + encodeURIComponent(params.statusId) : ''
            let searchProperty = (params.hasOwnProperty('searchProperty'))? "&searchProperty=" + encodeURIComponent(params.searchProperty) : ''
            let searchValue = (params.hasOwnProperty('searchValue'))? "&searchValue=" + encodeURIComponent(params.searchValue) : ''
            let divisionId = (params.hasOwnProperty('divisionId'))? "&divisionId=" + encodeURIComponent(params.divisionId) : ''
            let divisionLabel = (params.hasOwnProperty('divisionLabel'))? "&divisionLabel=" + encodeURIComponent(params.divisionLabel) : ''
            let query = '?' + page + pageChunk + statusId + searchProperty + searchValue + divisionId + divisionLabel

            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseUrl + '/list' + query,
                data: null
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r.data);
                }).catch(e => {
                    reject(e);
                });
            })
        },
        async getDropDownList(context, params = {}) {
            let query = ''
            if (params.hasOwnProperty('valueKey')) {
                query = '?value_key=' + params.valueKey
            }
            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseUrl + '/dropDownList' + query,
                data: null
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r.data);
                }).catch(e => {
                    reject(e);
                });
            })
        },
        async workingDropDownList(context, params = {}) {
            let query = '?'
            if (params.hasOwnProperty('valueKey')) {
                query += 'value_key=' + params.valueKey
            }

            if (params.hasOwnProperty('division_name')) {
                query += '&division_name=' + params.division_name
            }
            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseUrl + '/workingDropDownList' + query,
                data: null
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r.data);
                }).catch(e => {
                    reject(e);
                });
            })
        }
    }

};

export default api
